import { render, staticRenderFns } from "./ProductList1.vue?vue&type=template&id=08a97f80&scoped=true&"
import script from "./ProductList1.vue?vue&type=script&lang=js&"
export * from "./ProductList1.vue?vue&type=script&lang=js&"
import style0 from "./ProductList1.vue?vue&type=style&index=0&id=08a97f80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a97f80",
  null
  
)

export default component.exports